import React from "react";
import warningCircle from "../assets/svg/warning-circle.svg";
import Image from "@vfuk/core-image";

type WarningProps = {
  altText: string;
};

export const WarningCircle = ({ altText }: WarningProps) => {
  return (
    <Image
      alt={altText}
      sm={{
        src: warningCircle,
      }}
    />
  );
};
